import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { CONSTANT } from '../../../utils/constants';

function AnalyticsTimeRange({ label, dates, handleDates, mode, handleMode }) {
  useEffect(() => {
    switch (mode) {
      case 'LAST_12_MONTHS':
        handleDates({
          start_dt: new Date(Date.now() - 12 * 30 * 24 * 60 * 60 * 1000),
          end_dt: new Date()
        });
        break;
      case 'ALL':
        handleDates({
          start_dt: new Date(2021, 3, 1),
          end_dt: new Date()
        });
        break;
      case 'CUSTOM':
        break;
      default:
        break;
    }
  }, [mode]);

  const onChange = (key, value) => {
    handleDates({
      ...dates,
      [key]: value
    });
  };

  return (
    <div className="flex flex-col gap-y-1 w-full">
      <label className="text-slate-600">{label}</label>
      <Dropdown
        value={mode}
        options={CONSTANT.backoffice.analytics.timeRangesModes}
        optionLabel="label"
        onChange={(e) => handleMode(e.value)}
        placeholder="Sélectionner un mode"
      />
      <div className="grid grid-cols-2 gap-2">
        <Calendar
          value={new Date(dates?.start_dt)}
          onChange={(e) => onChange('start_dt', e.value)}
          view="month"
          dateFormat="MM yy"
          locale="fr"
          disabled={mode !== 'CUSTOM'}
          className={classNames({ 'bg-gray-200': mode !== 'CUSTOM' })}
          inputClassName={classNames({ 'font-medium': mode !== 'CUSTOM' })}
          maxDate={new Date(dates?.end_dt)}
        />
        <Calendar
          value={new Date(dates?.end_dt)}
          onChange={(e) => onChange('end_dt', e.value)}
          view="month"
          dateFormat="MM yy"
          locale="fr"
          disabled={mode !== 'CUSTOM'}
          className={classNames({ 'bg-gray-200': mode !== 'CUSTOM' })}
          inputClassName={classNames({ 'font-medium': mode !== 'CUSTOM' })}
          minDate={new Date(dates?.start_dt)}
        />
      </div>
    </div>
  );
}

export default AnalyticsTimeRange;
